import { Injectable } from '@angular/core';
import { NzDrawerService } from 'ng-zorro-antd/drawer';

import { GroupCustomPrivateSegmentsDrawerComponent } from './group-custom-private-segments-drawer.component';

import { PrivateSegmentsDrawerData } from './group-custom-private-segments-drawer.helper';

@Injectable()
export class GroupCustomPrivateSegmentsDrawerService {
  constructor(private readonly drawerService: NzDrawerService) {}

  openPrivateSegmentsDrawer(data: PrivateSegmentsDrawerData) {
    return this.drawerService.create({
      nzBodyStyle: { padding: 0 },
      nzClosable: false,
      nzContent: GroupCustomPrivateSegmentsDrawerComponent,
      nzData: { data },
      nzMaskClosable: false,
      nzTitle: data?.privateSegment?._id
        ? $localize`:@@groupCustomPrivateSegmentsDrawer.segmentEditTitle: Edit private segment`
        : $localize`:@@groupCustomPrivateSegmentsDrawer.segmentAddTitle: Add private segment`,
      nzWidth: '500px',
      nzZIndex: 999,
    }).afterClose;
  }
}
